export const readonlyWarningTextsPath = 'components.managePaymentMethods.readonlyWarnings';
export function getReadonlyWarning(data) {
    const { isPreview, isSampleRelationship, texts } = data;
    if (isSampleRelationship) {
        return texts.testAgreement();
    }
    if (isPreview) {
        return texts.previewMode();
    }
    return null;
}
